<template>
    <div :class="phoneClass || 'home-container-wrapper'" class="tabs">
        <div class="list-btn chart" @click="changeTabActive(3)" v-if="phoneClass">
            <img src="../../../assets/img/icon/home-chart-active.png" v-if="tabActive === 3">
            <img src="../../../assets/img/icon/home-chart.png" v-else>
            
        </div>
        <div class="list-btn" @click="changeTabActive(1)">
            <img src="../../../assets/img/icon/home-datalist-active.png" v-if="tabActive === 1">
            <img src="../../../assets/img/icon/home-datalist.png" v-else>
        </div>
        <div class="list-btn" @click="changeTabActive(2)">
            <img src="../../../assets/img/icon/home-map-active.png" v-if="tabActive === 2">
            <img src="../../../assets/img/icon/home-map.png" v-else>
        </div>
    </div>
</template>

<script>
import {refresh} from "core/winSize"
export default {
    components: {},
    data() {
        return {
            phoneClass: '',
            tabActive: 1
        }
    },
    watch: {},
    computed: {},
    created() {
        refresh(this,'phoneClass-tab');
        window.onresize = function(){
			setTimeout(function(){
				refresh(this,'phoneClass-tab');
			},10)
		};
    },
    mounted() {},
    methods: {
        changeTabActive(item) {
            this.tabActive = item
            this.$emit('changeTabActive', item)
        }
    },
}
</script>

<style lang='scss' scoped>
.tabs {
    display: flex;
    align-items: center;
}
.home-container-wrapper {
    width: 76px;
    height: 26px;
    .list-btn {
        height: 100%;
        img {
            width: 38px;
            height: 26px;
        }
    }
    
}
.phoneClass-tab {
    img {
        width: 44px;
        height: 32px;
    }
}
</style>